import React, { useEffect, useState, useRef } from "react";
import * as S from "./styles";
import ArrowDown from '../../../assets/icons/arrow-down-white.svg';
import ArrowDownTwo from '../../../assets/icons/arrowDownWhiteTwo.svg';
import { Auxiliar, BodyG, BodyGSpan, H5, TaglineG, TaglineM } from "../../../styles/stylesTypography";
import { theme } from "../../../styles/theme";
import InputV2 from "../../input/input_v2";
import ButtonList from "../../button-list";
import Modal from "../../../components/modal/modalGenericV2";
import ButtonFilter from "../../button-filter/indexV2";
import ModalImage from '../../../assets/modalTesteGratis.png';
import ButtonV2 from '../../button/button_v2';
import ModalGeneric from '../../modal/modalGeneric';
import maintainUtm from "../../../services/maintainUtm";
import ModalReativacao from "../../modal/modalReativacao";
import { getIsClienteAntigo } from "../../../services/bloqueioAcesso";

let user = JSON.parse(localStorage.getItem("@userinfo"));

const FilterCompendio = ({ isDispensed, setIsDispensed, filters, updateFilter, loading }) => {
  // Estados para os filtros
  const [openSelect, setOpenSelect] = useState(null);
  const [filter, setFilter] = useState({});
  const [filterOptions, setFilterOptions] = useState({
    order_by: {},
    active_ingredients: [],
    manufacturer: [],
    product_classes: [],
    toxicological_classes: [],
    exceptions: [],
    aplication_modes: [],
    dose: 0,
    numero_aplicacoes: 0
  });
  const isBlocked = user?.contrato?.dias_restante <= 0;
  const [showModalBlocked, setShowModalBlocked] = useState(false);
  // Conta que ja foi cliente pagante recebe a modal de reativacao, nao a oferta
  // de primeira compra. A rota devolve as duas informacoes de uma vez.
  const [clienteAntigo, setClienteAntigo] = useState(false);
  const [inativoDesde, setInativoDesde] = useState(null);

  const [selectedOptions, setSelectedOptions] = useState({
    order_by: {},
    active_ingredients: [],
    manufacturer: [],
    product_classes: [],
    toxicological_classes: [],
    exceptions: [],
    aplication_modes: [],
    dose: 0,
    numero_aplicacoes: 0
  });

  const [orderByOptions] = useState([
    { field: "data_revisao", order: "DESC", label: "Data Atualização" },
    { field: "nome_comercial", order: "ASC", label: "Nome do produto" },
    { field: "nome_tecnico", order: "ASC", label: "Principio ativo" },
    { field: "dosagem_minima", order: "ASC", label: "Dosagem minima" },
    { field: "dosagem_maxima", order: "ASC", label: "Dosagem maxima" },
    { field: "calda_terrestre", order: "ASC", label: "Volume de calda terrestre" },
    { field: "calda_aerea", order: "ASC", label: "Volume de calda aerea" },
    { field: "numero_aplicacoes_minimo", order: "ASC", label: "Qtd. Aplicação minima" },
    { field: "numero_aplicacoes_maximo", order: "ASC", label: "Qtd. Aplicação maxima" },
  ])

  // Estado do switch "Biológicos"
  const snapshotOptionsRef = useRef("");
  const orderByWrapperRef = useRef(null);
  const [orderByOpenUp, setOrderByOpenUp] = useState(false);

  const toggleSelect = (filter) => {
    if (openSelect === null && filter !== null) {
      snapshotOptionsRef.current = JSON.stringify(selectedOptions);
    }
    setOpenSelect(openSelect === filter ? null : filter);
  };

  const selectOption = (filter, value) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [filter]: value,
    }));
    setOpenSelect(null);
  };

  // Chamado quando o usuário confirma a seleção pendente no ButtonFilterV2
  // (botão APLICAR) - substitui o antigo addSelectOption (que aplicava a
  // cada clique numa opção, deixando o efeito de fechamento do dropdown
  // disparar a busca). Segue o mesmo padrão do clearOrderBy: atualiza o
  // snapshot junto pra o efeito de [openSelect] não repetir a busca ao
  // fechar o painel logo em seguida (o LIMPAR agora é interno ao próprio
  // ButtonFilterV2 - só afeta a seleção pendente do painel, some junto).
  const handleApplyFilter = (filterKey, values) => {
    setSelectedOptions((prev) => {
      const updated = {
        ...prev,
        [filterKey]: values,
      };
      snapshotOptionsRef.current = JSON.stringify(updated);
      updateFilter(updated);
      return updated;
    });
  };

  const setDose = (e) => {
    const value = parseInt(e.target.value);
    const options = selectedOptions
    options['dose'] = value;
    setSelectedOptions(options);
    updateFilter(options);
  }

  const setNumeroAplicacoes = (e) => {
    const value = parseInt(e.target.value);
    const options = selectedOptions
    options['numero_aplicacoes'] = value;
    setSelectedOptions(options);
    updateFilter(options);
  }

  const selectOrderBy = (filterOrderBy) => {
    let response = {};
    for (let i = 0; i < orderByOptions.length; i++) {
      const op = orderByOptions[i];
      if (op.field === filterOrderBy.field) {
        response = op
      }
    }
    return response;
  }

  const goToPlansReativar = () => {
    setShowModalBlocked(false);
    window.location = '/planos?button=web-modal-reativar';
  };

  const openConsultorWhatsapp = () => {
    window.open('https://wa.me/5515996577718', '_blank');
  };

  const goToPlansWithCupom = () => {
    setShowModalBlocked(false);
    const currentCupom = new URLSearchParams(window.location.search).get('cupom');
    const cupom = currentCupom && currentCupom !== 'null'
      ? currentCupom
      : 'BEMVINDO';

    window.location = `/planos?cupom=${encodeURIComponent(cupom)}${maintainUtm(undefined, true, ["cupom"])}`;
  }

  useEffect(() => {
    setFilter(filters)
  }, [filters])

  useEffect(() => {
    if (filter.active_ingredients !== undefined) {
      const orderBy = selectOrderBy(filter.order_by);
  
      if (filterOptions.order_by.field === undefined) {
        selectOption('order_by', orderBy);
      }
  
      setFilterOptions({
        order_by: orderBy,
        active_ingredients: filter.active_ingredients
          .map(i => ({ value: i.nome_tecnico, label: i.nome_tecnico }))
          .sort((a, b) => (a?.label || "").localeCompare(b?.label || "")),
  
        manufacturer: filter.manufacturer
          .map(m => ({ value: m.fabricante, label: m.fabricante }))
          .sort((a, b) => (a?.label || "").localeCompare(b?.label || "")),
  
        product_classes: [...filter.product_classes]
          .sort((a, b) => (a?.label || "").localeCompare(b?.label || "")),
  
        toxicological_classes: [...filter.toxicological_classes]
          .sort((a, b) => (a?.label || "").localeCompare(b?.label || "")),
  
        exceptions: [...filter.exceptions]
          .sort((a, b) => (a?.label || "").localeCompare(b?.label || "")),
  
        aplication_modes: [...filter.aplication_modes]
          .sort((a, b) => (a?.label || "").localeCompare(b?.label || "")),
      });
    }
  }, [filter]);
  

  useEffect(() => {
    if (openSelect === null) {
      if (selectedOptions.order_by.field !== undefined) {
        const currentOptionsStr = JSON.stringify(selectedOptions);
        if (currentOptionsStr !== snapshotOptionsRef.current) {
          updateFilter(selectedOptions)
        }
      }
    }
  }, [openSelect])

  useEffect(() => {
    if (openSelect === "order_by") {
      const checkPosition = () => {
        if (!orderByWrapperRef.current) return;
        const rect = orderByWrapperRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        const estimatedDropdownHeight = 260;
        const spaceBelow = viewportHeight - rect.bottom;
        setOrderByOpenUp(spaceBelow < estimatedDropdownHeight);
      };

      checkPosition();
      window.addEventListener("resize", checkPosition);

      return () => {
        window.removeEventListener("resize", checkPosition);
      };
    } else {
      setOrderByOpenUp(false);
    }
  }, [openSelect]);

  const handleBlockedAction = async (callback) => {
    if (isBlocked) {
      const { isCliente, inativoDesde: desde } = await getIsClienteAntigo();

      setClienteAntigo(isCliente);
      setInativoDesde(desde);
      setShowModalBlocked(true);
      return;
    }
    callback();
  };

  const clearOrderBy = () => {
    const defaultOrderBy = orderByOptions[0] || {};
    setSelectedOptions((prev) => {
      const updated = {
        ...prev,
        order_by: defaultOrderBy,
      };
      snapshotOptionsRef.current = JSON.stringify(updated);
      updateFilter(updated);
      return updated;
    });
  };

  const canClearOrderBy =
    !!(selectedOptions.order_by && selectedOptions.order_by.field) &&
    !!(orderByOptions[0] && orderByOptions[0].field) &&
    selectedOptions.order_by.field !== orderByOptions[0].field;

  return (
    <S.Container>
      {/* PRINCIPAL FILTERS */}
      <S.PricipalFilters>

        <S.CustomSelect ref={orderByWrapperRef}>
          <S.SelectButton
            onClick={() => handleBlockedAction(() => toggleSelect("order_by"))}
            style={{ cursor: isBlocked ? "not-allowed" : "pointer", opacity: isBlocked ? 0.5 : 1 }}
          >
            <img src={ArrowDownTwo} alt="Seta Apontada para baixo" />

            <TaglineM color={theme.colors.white.Branco} fontWeight={800}>
              {selectedOptions.order_by.label}
            </TaglineM>

            <S.Arrow className={openSelect === "order_by" ? "open" : ""}>
              <img src={ArrowDown} alt="Seta Apontada para baixo" />
            </S.Arrow>
          </S.SelectButton>

          {openSelect === "order_by" && (
            <S.SelectOptions openUp={orderByOpenUp}>
              {orderByOptions.map((option, i) => (
                <S.Option
                  key={`order_by_${i}`}
                  onClick={() => selectOption('order_by', option)}
                >
                  <Auxiliar color={theme.colors.gray.Cinza_2} fontWeight={800}>
                    {option.label}
                  </Auxiliar>
                </S.Option>
              ))}
            </S.SelectOptions>
          )}
        </S.CustomSelect>

        {/* SWITCH PARA FILTRAR BIOLÓGICOS */}
        <S.BiologicoSwitch
          onClick={() => handleBlockedAction(() => setIsDispensed(!isDispensed))}
          style={{ cursor: isBlocked ? "not-allowed" : "pointer", opacity: isBlocked ? 0.5 : 1 }}
        >

          <S.SwitchContainer isActive={isDispensed}>
            <S.SwitchCircle isActive={isDispensed} />
          </S.SwitchContainer>

          <TaglineG color={theme.colors.gray.Cinza_2} fontWeight={600}>
            DISPENSADOS DE RECEITUÁRIO
          </TaglineG>
        </S.BiologicoSwitch>
      </S.PricipalFilters>

      {/* OUTROS FILTROS */}
      <S.OtherFilters>
        {[
          { key: "active_ingredients", label: "PRINCÍPIO ATIVO" },
          { key: "manufacturer", label: "FABRICANTE" },
          { key: "product_classes", label: "CLASSE DO PRODUTO" },
          { key: "toxicological_classes", label: "CLASSE TOXICOLÓGICA" },
          { key: "exceptions", label: "FASE" },
          { key: "aplication_modes", label: "MODO APLICAÇÃO" }
        ].map(({ key, label }) => (
          <ButtonFilter
            key_value={key}
            label={label}
            options={filterOptions}
            selectedOptions={selectedOptions}
            loading={loading}
            onApply={(filterKey, values) =>
              handleBlockedAction(() => handleApplyFilter(filterKey, values))
            }
            toggleSelect={(filterKey) =>
              handleBlockedAction(() => toggleSelect(filterKey))
            }
            openSelect={openSelect}
            justIconFilter={true}
            paddingButtonOthersFilters="8px 12px"
          />
        ))}
      </S.OtherFilters>

      <ModalGeneric
        show={showModalBlocked}
        onHide={() => setShowModalBlocked(false)}
        marginBottom='0'
      >

        {clienteAntigo ? (
          <S.ContainerModal>
            <ModalReativacao
              inativoDesde={inativoDesde}
              onReativar={goToPlansReativar}
              onFalarConsultor={openConsultorWhatsapp}
            />
          </S.ContainerModal>
        ) : (
        <S.ContainerModal>
          <img src={ModalImage} alt='Imagem garota olhando um presente' />

          <H5>Seu teste grátis terminou</H5>

          <BodyG>
            Assine agora mesmo utilizando o cupom <BodyGSpan color={theme.colors.red.Vermelho_erro}>BEMVINDO</BodyGSpan> e garanta <BodyGSpan color={theme.colors.red.Vermelho_erro}>90% de desconto</BodyGSpan> na primeira mensalidade dos planos Basic, Light ou Pro ou <BodyGSpan color={theme.colors.red.Vermelho_erro}>20% de desconto</BodyGSpan> na sua primeira compra de créditos Pré-pago.
          </BodyG>

          <Auxiliar color={theme.colors.gray.Cinza_6}>
            Assine para ter Receitas Agronômicas atualizadas, Envio para Defesas, Controle de ART/TRT, Emissão de FISPQ/FDS/Ficha de Emergência, Relatórios e mais.
          </Auxiliar>

          <S.ButtonPlans>
            <ButtonV2
              width='70%'
              height='60px'
              value='Ver Planos'
              outline={false}
              disabled={false}
              onClick={() => goToPlansWithCupom()}
              loading={false}
            ></ButtonV2>
          </S.ButtonPlans>
        </S.ContainerModal>
        )}
      </ModalGeneric>

    </S.Container>
  );
};

export default FilterCompendio;